import { DefaultSteps } from './default.steps';
import { LiftWearTankSteps } from './liftwear-tank.steps';
import { LiftWearCamiSteps } from './liftwear-cami.steps';
import { StepViewModel } from '../../models/step';
import { ProductHandle } from '../../../enums/ProductHandle.enum';
import { VNeckBraSteps } from './vneck_bra.steps';
import { EverydayUnderwearSteps } from './everyday-underwear.steps';
import { CamiBodysuitSteps } from './cami-bodysuit.steps';
import { BoldnessTankSteps } from './boldness-tank.steps';
import { LeggingsSteps } from './leggings.steps';
import { TankBodysuitSteps } from './tank-bodysuit.steps';
import { SculptwearSteps } from './sculptwear.steps';

export const StepsMetadata: {
  [handle in ProductHandle]: StepViewModel[] | undefined;
} = {
  [ProductHandle.SuperPowerShort]: SculptwearSteps,
  [ProductHandle.SuperPowerShortV2]: SculptwearSteps,
  [ProductHandle.SuperPowerBrief]: SculptwearSteps,
  [ProductHandle.SuperPowerThong]: SculptwearSteps,
  [ProductHandle.QueenBrief]: SculptwearSteps,
  [ProductHandle.WaistHeroCincher]: SculptwearSteps,
  [ProductHandle.LiftWearTank]: LiftWearTankSteps,
  [ProductHandle.LiftWearCami]: LiftWearCamiSteps,
  [ProductHandle.BoldnessTank]: BoldnessTankSteps,
  [ProductHandle.SilhouetteBra]: VNeckBraSteps,
  [ProductHandle.CrossoverBra]: VNeckBraSteps,
  [ProductHandle.VNeckBra]: VNeckBraSteps,
  [ProductHandle.EGiftCard]: undefined,
  [ProductHandle.IntimatesBag]: undefined,
  [ProductHandle.TapeMeasure]: undefined,
  [ProductHandle.CamiBodysuit]: CamiBodysuitSteps,
  [ProductHandle.EverydayCottonThong]: EverydayUnderwearSteps,
  [ProductHandle.EverydayCottonBrief]: EverydayUnderwearSteps,
  [ProductHandle.SilhouetteBrief]: EverydayUnderwearSteps,
  [ProductHandle.EverReadyPant]: LeggingsSteps,
  [ProductHandle.LeggingTwo]: LeggingsSteps,
  [ProductHandle.BoldnessBodysuit]: TankBodysuitSteps,
  [ProductHandle.TankBodysuit]: TankBodysuitSteps,
  [ProductHandle.SculptwaveCapri]: DefaultSteps,
};
